import TrainingItem from './components/TrainingItem';

const seinTerminalTraining = [
  {
    name: 'Tasks, Deliverables & Milestones',
    description:
      'An introduction to how the SEIN Terminal and the Sherpa application uses Tasks, Deliverables and Milestones to help execute projects.',
    path: 'training_videos/cclf/sherpa_tdm.mp4',
  },
  {
    name: 'Approval',
    description: 'An introduction to how the approval function can be used to manage the draw process and communications.',
    path: 'training_videos/cclf/approval_feature.mp4',
  },
  {
    name: 'Developer Form',
    description: 'An review of how developers submit their Chicago Rebuild Application via the SEIN Terminal.',
    path: 'training_videos/cclf/CCLF_Developer_Form_Tutorial.mp4',
  },
  {
    name: 'Rover',
    description: 'CCLF Rover. An overview of the Rover application.',
    path: 'training_videos/cclf/CCLF_Rover_Training.mp4',
  },
];

const Learn = () => {
  return (
    <div className='max-w-7xl mx-auto'>
      <div className='pb-6'>
        <h2 className='m-0'>SEIN Terminal Training</h2>
        <p className='text-neutralColor-normal'>Learn about SEIN Terminal features and how to use them.</p>
      </div>
      <div className='bg-white ring-1 ring-gray-300 overflow-hidden rounded-xl'>
        <table className='min-w-full divide-y divide-y-300'>
          <thead className='bg-gray-50 text-left text-neutralColor-medium'>
            <tr>
              <th className='p-4 w-1/6'>Feature Name</th>
              <th className='p-4'>Description</th>
              <th className='p-4 w-1/6'>Resource</th>
            </tr>
          </thead>
          <tbody className='text-sm divide-y'>
            {seinTerminalTraining.map((train) => (
              <TrainingItem key={train.name} name={train.name} description={train.description} s3_path={train.path} />
            ))}
          </tbody>
        </table>
      </div>
      <div className='bg-white rounded-xl p-6 flex flex-col justify-center  items-center space-y-5 mt-5'>
        <h2 className='text-primaryColor-normal mb-0'>Still Need Help ?</h2>
        <p className='w-2/3 text-center'>
          Our specialists are always happy to help. Contact us during standard business hours or email us 24/7 at support@stp.tech and we'll
          get back to you or Chat with us.
        </p>
      </div>
    </div>
  );
};

export default Learn;
